export const fakePaymentCountries = [
  {"value":"Italy","label":"Italia"},
  {"value":"Afghanistan","label":"Afghanistan"},
  {"value":"Albania","label":"Albania"},
  {"value":"Algeria","label":"Algeria"},
  {"value":"Andorra","label":"Andorra"},
  {"value":"Angola","label":"Angola"},
  {"value":"Anguilla","label":"Anguilla"},
  {"value":"Antarctica","label":"Antartide"},
  {"value":"Antigua and Barbuda","label":"Antigua e Barbuda"},
  {"value":"Netherlands Antilles","label":"Antille Olandesi"},
  {"value":"Saudi Arabia","label":"Arabia Saudita"},
  {"value":"Argentina","label":"Argentina"},
  {"value":"Armenia","label":"Armenia"},
  {"value":"Aruba","label":"Aruba"},
  {"value":"Australia","label":"Australia"},
  {"value":"Austria","label":"Austria"},
  {"value":"PS","label":"Autorità Palestinese"},
  {"value":"Azerbaidjan","label":"Azerbaigian"},
  {"value":"Bahamas","label":"Bahamas"},
  {"value":"Bahrain","label":"Bahrein"},
  {"value":"Bangladesh","label":"Bangladesh"},
  {"value":"Barbados","label":"Barbados"},
  {"value":"Belgium","label":"Belgio"},
  {"value":"Belize","label":"Belize"},
  {"value":"Benin","label":"Benin"},
  {"value":"Bermuda","label":"Bermuda"},
  {"value":"Bhutan","label":"Bhutan"},
  {"value":"Belarus","label":"Bielorussia"},
  {"value":"Bolivia","label":"Bolivia"},
  {"value":"Bosnia-Herzegovina","label":"Bosnia-Erzegovina"},
  {"value":"Botswana","label":"Botswana"},
  {"value":"Brazil","label":"Brasile"},
  {"value":"Brunei","label":"Brunei"},
  {"value":"Bulgaria","label":"Bulgaria"},
  {"value":"BurkinaFaso","label":"Burkina Faso"},
  {"value":"Burundi","label":"Burundi"},
  {"value":"Cambodia","label":"Cambogia"},
  {"value":"Cameroon","label":"Camerun"},
  {"value":"Canada","label":"Canada"},
  {"value":"Cape Verde","label":"Capo Verde"},
  {"value":"Chad","label":"Ciad"},
  {"value":"Chile","label":"Cile"},
  {"value":"China","label":"Cina"},
  {"value":"Cyprus","label":"Cipro"},
  {"value":"Vatican City State","label":"Città del Vaticano"},
  {"value":"Colombia","label":"Colombia"},
  {"value":"Comoros","label":"Comore"},
  {"value":"Congo","label":"Congo"},
  {"value":"South Korea","label":"Corea"},
  {"value":"North Korea","label":"Corea del Nord"},
  {"value":"Ivory Coast(Cote D Ivoire)","label":"Costa d'Avorio"},
  {"value":"CostaRica","label":"Costa Rica"},
  {"value":"Croatia","label":"Croazia"},
  {"value":"Cuba","label":"Cuba"},
  {"value":"Denmark","label":"Danimarca"},
  {"value":"Dominica","label":"Dominica"},
  {"value":"Ecuador","label":"Ecuador"},
  {"value":"Egypt","label":"Egitto"},
  {"value":"El Salvador","label":"El Salvador"},
  {"value":"United Arab Emirates","label":"Emirati Arabi Uniti"},
  {"value":"Eritrea","label":"Eritrea"},
  {"value":"Estonia","label":"Estonia"},
  {"value":"Ethiopia","label":"Etiopia"},
  {"value":"Philippines","label":"Filippine"},
  {"value":"Finland","label":"Finlandia"},
  {"value":"France","label":"Francia"},
  {"value":"Gabon","label":"Gabon"},
  {"value":"Gambia","label":"Gambia"},
  {"value":"Georgia","label":"Georgia"},
  {"value":"S.Georgia & S.SandwichIsls","label":"Georgia del Sud e Sandwich Australi"},
  {"value":"Germany","label":"Germania"},
  {"value":"Ghana","label":"Ghana"},
  {"value":"Jamaica","label":"Giamaica"},
  {"value":"Japan","label":"Giappone"},
  {"value":"Gibraltar","label":"Gibilterra"},
  {"value":"Djibouti","label":"Gibuti"},
  {"value":"Jordan","label":"Giordania"},
  {"value":"Great Britain","label":"Gran Bretagna"},
  {"value":"Greece","label":"Grecia"},
  {"value":"Grenada","label":"Grenada"},
  {"value":"Greenland","label":"Groenlandia"},
  {"value":"Guadeloupe(French)","label":"Guadalupe"},
  {"value":"Guam(USA)","label":"Guam"},
  {"value":"Guatemala","label":"Guatemala"},
  {"value":"GG","label":"Guernsey"},
  {"value":"French Guyana","label":"Guiana francese"},
  {"value":"Guinea","label":"Guinea"},
  {"value":"EquatorialGuinea","label":"Guinea equatoriale"},
  {"value":"Guinea Bissau","label":"Guinea-Bissau"},
  {"value":"Guyana","label":"Guyana"},
  {"value":"Haiti","label":"Haiti"},
  {"value":"Honduras","label":"Honduras"},
  {"value":"Hong Kong","label":"Hong Kong"},
  {"value":"India","label":"India"},
  {"value":"Indonesia","label":"Indonesia"},
  {"value":"Iran","label":"Iran"},
  {"value":"Iraq","label":"Iraq"},
  {"value":"Ireland","label":"Irlanda"},
  {"value":"Iceland","label":"Islanda"},
  {"value":"Ascension Island","label":"Isola Ascensione"},
  {"value":"Bouvet Island","label":"Isola Bouvet"},
  {"value":"IM","label":"Isola di Man"},
  {"value":"Cayman Islands","label":"Isole Cayman"},
  {"value":"Christmas Island","label":"Isole Christmas"},
  {"value":"Cocos(Keeling) Islands","label":"Isole Cocos (Keeling)"},
  {"value":"Cook Islands","label":"Isole Cook"},
  {"value":"Falkland Islands","label":"Isole Falkland (Malvinas)"},
  {"value":"Faroe Islands","label":"Isole Faroe"},
  {"value":"Fiji","label":"Isole Fiji"},
  {"value":"Heard and McDonald Islands","label":"Isole Heard e McDonald"},
  {"value":"Northern Mariana Islands","label":"Isole Marianne Settentrionali"},
  {"value":"Marshall Islands","label":"Isole Marshall"},
  {"value":"USA Minor Outlying Islands","label":"Isole minori degli Stati Uniti"},
  {"value":"Norfolk Island","label":"Isole Norfolk"},
  {"value":"Solomon Islands","label":"Isole Salomone"},
  {"value":"Turks and Caicos Islands","label":"Isole Turks e Caicos"},
  {"value":"Virgin Islands(British)","label":"Isole Vergini (GB)"},
  {"value":"Virgin Islands(USA)","label":"Isole Vergini (USA)"},
  {"value":"Israele","label":"Israele"},
  {"value":"Yugoslavia","label":"Iugoslavia"},
  {"value":"JE","label":"Jersey"},
  {"value":"Kazakhstan","label":"Kazakistan"},
  {"value":"Kenya","label":"Kenya"},
  {"value":"Kyrgyzstan","label":"Kirghizistan"},
  {"value":"Kiribati","label":"Kiribati"},
  {"value":"Kuwait","label":"Kuwait"},
  {"value":"Laos","label":"Laos"},
  {"value":"Lesotho","label":"Lesotho"},
  {"value":"Latvia","label":"Lettonia"},
  {"value":"Lebanon","label":"Libano"},
  {"value":"Liberia","label":"Liberia"},
  {"value":"Libya","label":"Libia"},
  {"value":"Liechtenstein","label":"Liechtenstein"},
  {"value":"Lithuania","label":"Lituania"},
  {"value":"Luxembourg","label":"Lussemburgo"},
  {"value":"Macau","label":"Macao - R.A.S."},
  {"value":"Macedonia","label":"Macedonia, ex Repubblica Jugoslava di"},
  {"value":"Madagascar","label":"Madagascar"},
  {"value":"Malawi","label":"Malawi"},
  {"value":"Maldives","label":"Maldive"},
  {"value":"Malaysia","label":"Malesia"},
  {"value":"Mali","label":"Mali"},
  {"value":"Malta","label":"Malta"},
  {"value":"Morocco","label":"Marocco"},
  {"value":"Martinique(French)","label":"Martinica"},
  {"value":"Mauritania","label":"Mauritania"},
  {"value":"Mauritius","label":"Mauritius"},
  {"value":"Mayotte","label":"Mayotte"},
  {"value":"Mexico","label":"Messico"},
  {"value":"Micronesia","label":"Micronesia"},
  {"value":"Moldavia","label":"Moldavia"},
  {"value":"Monaco","label":"Monaco"},
  {"value":"Mongolia","label":"Mongolia"},
  {"value":"Montserrat","label":"Montserrat"},
  {"value":"Mozambique","label":"Mozambico"},
  {"value":"Myanmar","label":"Myanmar"},
  {"value":"Namibia","label":"Namibia"},
  {"value":"Nauru","label":"Nauru"},
  {"value":"Nepal","label":"Nepal"},
  {"value":"Nicaragua","label":"Nicaragua"},
  {"value":"Niger","label":"Niger"},
  {"value":"Nigeria","label":"Nigeria"},
  {"value":"Niue","label":"Niue"},
  {"value":"Norway","label":"Norvegia"},
  {"value":"New Caledonia(French)","label":"Nuova Caledonia"},
  {"value":"New Zealand","label":"Nuova Zelanda"},
  {"value":"Oman","label":"Oman"},
  {"value":"Netherlands","label":"Paesi Bassi"},
  {"value":"Pakistan","label":"Pakistan"},
  {"value":"Palau","label":"Palau"},
  {"value":"Panama","label":"Panama"},
  {"value":"Papua New Guinea","label":"Papua Nuova Guinea"},
  {"value":"Paraguay","label":"Paraguay"},
  {"value":"Peru","label":"Perù"},
  {"value":"Pitcairn Island","label":"Pitcairn"},
  {"value":"Polynesia(French)","label":"Polinesia francese"},
  {"value":"Poland","label":"Polonia"},
  {"value":"Portugal","label":"Portogallo"},
  {"value":"Puerto Rico","label":"Portorico"},
  {"value":"Qatar","label":"Qatar"},
  {"value":"United Kingdom","label":"Regno Unito"},
  {"value":"Czech Republic","label":"Repubblica Ceca"},
  {"value":"Central African Republic","label":"Repubblica Centrafricana"},
  {"value":"CD","label":"Repubblica Democratica del Congo"},
  {"value":"San Marino","label":"Repubblica di San Marino"},
  {"value":"Dominican Republic","label":"Repubblica Dominicana"},
  {"value":"Reunion(French)","label":"Riunione"},
  {"value":"Romania","label":"Romania"},
  {"value":"Rwanda","label":"Ruanda"},
  {"value":"Russian Federation","label":"Russia"},
  {"value":"Saint Kitts & Nevis Anguilla","label":"Saint Kitts e Nevis"},
  {"value":"Saint Lucia","label":"Saint Lucia"},
  {"value":"Saint Pierre and Miquelon","label":"Saint Pierre et Miquelon"},
  {"value":"Saint Vincent & Grenadines","label":"Saint Vincent e Grenadine"},
  {"value":"Samoa","label":"Samoa"},
  {"value":"American Samoa","label":"Samoa americane"},
  {"value":"Saint Helena","label":"Sant'Elena"},
  {"value":"Saint Tome(Sao Tome) and Principe","label":"Sao Tome e Principe"},
  {"value":"Senegal","label":"Senegal"},
  {"value":"Seychelles","label":"Seychelles"},
  {"value":"Sierra Leone","label":"Sierra Leone"},
  {"value":"Singapore","label":"Singapore"},
  {"value":"Syria","label":"Siria"},
  {"value":"Slovak Republic","label":"Slovacchia"},
  {"value":"Slovenia","label":"Slovenia"},
  {"value":"Somalia","label":"Somalia"},
  {"value":"Spain","label":"Spagna"},
  {"value":"Sri Lanka","label":"Sri Lanka"},
  {"value":"United States","label":"Stati Uniti"},
  {"value":"South Africa","label":"Sud Africa"},
  {"value":"Sudan","label":"Sudan"},
  {"value":"Suriname","label":"Suriname"},
  {"value":"Svalbard and Jan Mayen Islands","label":"Svalbard e Jan Mayen"},
  {"value":"Sweden","label":"Svezia"},
  {"value":"Switzerland","label":"Svizzera"},
  {"value":"Swaziland","label":"Swaziland"},
  {"value":"Tadjikistan","label":"Tagikistan"},
  {"value":"Thailand","label":"Tailandia"},
  {"value":"Taiwan","label":"Taiwan"},
  {"value":"Tanzania","label":"Tanzania"},
  {"value":"French Southern Territories","label":"Terre Australi e Antartiche Francesi"},
  {"value":"British Indian Ocean Territory","label":"Territori inglesi dell'Oceano Indiano"},
  {"value":"EastTimor","label":"Timor Est"},
  {"value":"Togo","label":"Togo"},
  {"value":"Tokelau","label":"Tokelau"},
  {"value":"Tonga","label":"Tonga"},
  {"value":"Trinidad and Tobago","label":"Trinidad e Tobago"},
  {"value":"TA","label":"Tristan da Cunha"},
  {"value":"Tunisia","label":"Tunisia"},
  {"value":"Turkey","label":"Turchia"},
  {"value":"Turkmenistan","label":"Turkmenistan"},
  {"value":"Tuvalu","label":"Tuvalu"},
  {"value":"Ukraine","label":"Ucraina"},
  {"value":"Uganda","label":"Uganda"},
  {"value":"Hungary","label":"Ungheria"},
  {"value":"Uruguay","label":"Uruguay"},
  {"value":"Uzbekistan","label":"Uzbekistan"},
  {"value":"Vanuatu","label":"Vanuatu"},
  {"value":"Venezuela","label":"Venezuela"},
  {"value":"Vietnam","label":"Vietnam"},
  {"value":"Wallis and FutunaIslands","label":"Wallis e Futuna"},
  {"value":"Yemen","label":"Yemen"},
  {"value":"Zambia","label":"Zambia"},
  {"value":"Zimbabwe","label":"Zimbabwe"}
];

export const getCountries = (t) =>  {
  return [
    { value: "IT", label: t("options.country.IT") },
    { value: "AF", label: t("options.country.AF") },
    { value: "AL", label: t("options.country.AL") },
    { value: "DZ", label: t("options.country.DZ") },
    { value: "AD", label: t("options.country.AD") },
    { value: "AO", label: t("options.country.AO") },
    { value: "AI", label: t("options.country.AI") },
    { value: "AQ", label: t("options.country.AQ") },
    { value: "AG", label: t("options.country.AG") },
    { value: "AN", label: t("options.country.AN") },
    { value: "SA", label: t("options.country.SA") },
    { value: "AR", label: t("options.country.AR") },
    { value: "AM", label: t("options.country.AM") },
    { value: "AW", label: t("options.country.AW") },
    { value: "AU", label: t("options.country.AU") },
    { value: "AT", label: t("options.country.AT") },
    { value: "PS", label: t("options.country.PS") },
    { value: "AZ", label: t("options.country.AZ") },
    { value: "BS", label: t("options.country.BS") },
    { value: "BH", label: t("options.country.BH") },
    { value: "BD", label: t("options.country.BD") },
    { value: "BB", label: t("options.country.BB") },
    { value: "BE", label: t("options.country.BE") },
    { value: "BZ", label: t("options.country.BZ") },
    { value: "BJ", label: t("options.country.BJ") },
    { value: "BM", label: t("options.country.BM") },
    { value: "BT", label: t("options.country.BT") },
    { value: "BY", label: t("options.country.BY") },
    { value: "BO", label: t("options.country.BO") },
    { value: "BA", label: t("options.country.BA") },
    { value: "BW", label: t("options.country.BW") },
    { value: "BR", label: t("options.country.BR") },
    { value: "BN", label: t("options.country.BN") },
    { value: "BG", label: t("options.country.BG") },
    { value: "BF", label: t("options.country.BF") },
    { value: "BI", label: t("options.country.BI") },
    { value: "KH", label: t("options.country.KH") },
    { value: "CM", label: t("options.country.CM") },
    { value: "CA", label: t("options.country.CA") },
    { value: "CV", label: t("options.country.CV") },
    { value: "TD", label: t("options.country.TD") },
    { value: "CL", label: t("options.country.CL") },
    { value: "CN", label: t("options.country.CN") },
    { value: "CY", label: t("options.country.CY") },
    { value: "VA", label: t("options.country.VA") },
    { value: "CO", label: t("options.country.CO") },
    { value: "KM", label: t("options.country.KM") },
    { value: "CG", label: t("options.country.CG") },
    { value: "KR", label: t("options.country.KR") },
    { value: "KP", label: t("options.country.KP") },
    { value: "CI", label: t("options.country.CI") },
    { value: "CR", label: t("options.country.CR") },
    { value: "HR", label: t("options.country.HR") },
    { value: "CU", label: t("options.country.CU") },
    { value: "DK", label: t("options.country.DK") },
    { value: "DM", label: t("options.country.DM") },
    { value: "EC", label: t("options.country.EC") },
    { value: "EG", label: t("options.country.EG") },
    { value: "SV", label: t("options.country.SV") },
    { value: "AE", label: t("options.country.AE") },
    { value: "ER", label: t("options.country.ER") },
    { value: "EE", label: t("options.country.EE") },
    { value: "ET", label: t("options.country.ET") },
    { value: "PH", label: t("options.country.PH") },
    { value: "FI", label: t("options.country.FI") },
    { value: "FR", label: t("options.country.FR") },
    { value: "GA", label: t("options.country.GA") },
    { value: "GM", label: t("options.country.GM") },
    { value: "GE", label: t("options.country.GE") },
    { value: "GS", label: t("options.country.GS") },
    { value: "DE", label: t("options.country.DE") },
    { value: "GH", label: t("options.country.GH") },
    { value: "JM", label: t("options.country.JM") },
    { value: "JP", label: t("options.country.JP") },
    { value: "GI", label: t("options.country.GI") },
    { value: "DJ", label: t("options.country.DJ") },
    { value: "JO", label: t("options.country.JO") },
    { value: "GB", label: t("options.country.GB") },
    { value: "GR", label: t("options.country.GR") },
    { value: "GD", label: t("options.country.GD") },
    { value: "GL", label: t("options.country.GL") },
    { value: "GP", label: t("options.country.GP") },
    { value: "GU", label: t("options.country.GU") },
    { value: "GT", label: t("options.country.GT") },
    { value: "GG", label: t("options.country.GG") },
    { value: "GF", label: t("options.country.GF") },
    { value: "GN", label: t("options.country.GN") },
    { value: "GQ", label: t("options.country.GQ") },
    { value: "GW", label: t("options.country.GW") },
    { value: "GY", label: t("options.country.GY") },
    { value: "HT", label: t("options.country.HT") },
    { value: "HN", label: t("options.country.HN") },
    { value: "HK", label: t("options.country.HK") },
    { value: "IN", label: t("options.country.IN") },
    { value: "ID", label: t("options.country.ID") },
    { value: "IR", label: t("options.country.IR") },
    { value: "IQ", label: t("options.country.IQ") },
    { value: "IE", label: t("options.country.IE") },
    { value: "IS", label: t("options.country.IS") },
    { value: "AC", label: t("options.country.AC") },
    { value: "BV", label: t("options.country.BV") },
    { value: "IM", label: t("options.country.IM") },
    { value: "KY", label: t("options.country.KY") },
    { value: "CX", label: t("options.country.CX") },
    { value: "CC", label: t("options.country.CC") },
    { value: "CK", label: t("options.country.CK") },
    { value: "FK", label: t("options.country.FK") },
    { value: "FO", label: t("options.country.FO") },
    { value: "FJ", label: t("options.country.FJ") },
    { value: "HM", label: t("options.country.HM") },
    { value: "MP", label: t("options.country.MP") },
    { value: "MH", label: t("options.country.MH") },
    { value: "UM", label: t("options.country.UM") },
    { value: "NF", label: t("options.country.NF") },
    { value: "SB", label: t("options.country.SB") },
    { value: "TC", label: t("options.country.TC") },
    { value: "VG", label: t("options.country.VG") },
    { value: "VI", label: t("options.country.VI") },
    { value: "IL", label: t("options.country.IL") },
    { value: "YU", label: t("options.country.YU") },
    { value: "JE", label: t("options.country.JE") },
    { value: "KZ", label: t("options.country.KZ") },
    { value: "KE", label: t("options.country.KE") },
    { value: "KG", label: t("options.country.KG") },
    { value: "KI", label: t("options.country.KI") },
    { value: "KW", label: t("options.country.KW") },
    { value: "LA", label: t("options.country.LA") },
    { value: "LS", label: t("options.country.LS") },
    { value: "LV", label: t("options.country.LV") },
    { value: "LB", label: t("options.country.LB") },
    { value: "LR", label: t("options.country.LR") },
    { value: "LY", label: t("options.country.LY") },
    { value: "LI", label: t("options.country.LI") },
    { value: "LT", label: t("options.country.LT") },
    { value: "LU", label: t("options.country.LU") },
    { value: "MO", label: t("options.country.MO") },
    { value: "MK", label: t("options.country.MK") },
    { value: "MG", label: t("options.country.MG") },
    { value: "MW", label: t("options.country.MW") },
    { value: "MV", label: t("options.country.MV") },
    { value: "MY", label: t("options.country.MY") },
    { value: "ML", label: t("options.country.ML") },
    { value: "MT", label: t("options.country.MT") },
    { value: "MA", label: t("options.country.MA") },
    { value: "MQ", label: t("options.country.MQ") },
    { value: "MR", label: t("options.country.MR") },
    { value: "MU", label: t("options.country.MU") },
    { value: "YT", label: t("options.country.YT") },
    { value: "MX", label: t("options.country.MX") },
    { value: "FM", label: t("options.country.FM") },
    { value: "MD", label: t("options.country.MD") },
    { value: "MC", label: t("options.country.MC") },
    { value: "MN", label: t("options.country.MN") },
    { value: "MS", label: t("options.country.MS") },
    { value: "MZ", label: t("options.country.MZ") },
    { value: "MM", label: t("options.country.MM") },
    { value: "NA", label: t("options.country.NA") },
    { value: "NR", label: t("options.country.NR") },
    { value: "NP", label: t("options.country.NP") },
    { value: "NI", label: t("options.country.NI") },
    { value: "NE", label: t("options.country.NE") },
    { value: "NG", label: t("options.country.NG") },
    { value: "NU", label: t("options.country.NU") },
    { value: "NO", label: t("options.country.NO") },
    { value: "NC", label: t("options.country.NC") },
    { value: "NZ", label: t("options.country.NZ") },
    { value: "OM", label: t("options.country.OM") },
    { value: "NL", label: t("options.country.NL") },
    { value: "PK", label: t("options.country.PK") },
    { value: "PW", label: t("options.country.PW") },
    { value: "PA", label: t("options.country.PA") },
    { value: "PG", label: t("options.country.PG") },
    { value: "PY", label: t("options.country.PY") },
    { value: "PE", label: t("options.country.PE") },
    { value: "PN", label: t("options.country.PN") },
    { value: "PF", label: t("options.country.PF") },
    { value: "PL", label: t("options.country.PL") },
    { value: "PT", label: t("options.country.PT") },
    { value: "PR", label: t("options.country.PR") },
    { value: "QA", label: t("options.country.QA") },
    { value: "UK", label: t("options.country.UK") },
    { value: "CZ", label: t("options.country.CZ") },
    { value: "CF", label: t("options.country.CF") },
    { value: "CD", label: t("options.country.CD") },
    { value: "SM", label: t("options.country.SM") },
    { value: "DO", label: t("options.country.DO") },
    { value: "RE", label: t("options.country.RE") },
    { value: "RO", label: t("options.country.RO") },
    { value: "RW", label: t("options.country.RW") },
    { value: "RU", label: t("options.country.RU") },
    { value: "KN", label: t("options.country.KN") },
    { value: "LC", label: t("options.country.LC") },
    { value: "PM", label: t("options.country.PM") },
    { value: "VC", label: t("options.country.VC") },
    { value: "WS", label: t("options.country.WS") },
    { value: "AS", label: t("options.country.AS") },
    { value: "SH", label: t("options.country.SH") },
    { value: "ST", label: t("options.country.ST") },
    { value: "SN", label: t("options.country.SN") },
    { value: "SC", label: t("options.country.SC") },
    { value: "SL", label: t("options.country.SL") },
    { value: "SG", label: t("options.country.SG") },
    { value: "SY", label: t("options.country.SY") },
    { value: "SK", label: t("options.country.SK") },
    { value: "SI", label: t("options.country.SI") },
    { value: "SO", label: t("options.country.SO") },
    { value: "ES", label: t("options.country.ES") },
    { value: "LK", label: t("options.country.LK") },
    { value: "US", label: t("options.country.US") },
    { value: "ZA", label: t("options.country.ZA") },
    { value: "SD", label: t("options.country.SD") },
    { value: "SR", label: t("options.country.SR") },
    { value: "SJ", label: t("options.country.SJ") },
    { value: "SE", label: t("options.country.SE") },
    { value: "CH", label: t("options.country.CH") },
    { value: "SZ", label: t("options.country.SZ") },
    { value: "TJ", label: t("options.country.TJ") },
    { value: "TH", label: t("options.country.TH") },
    { value: "TW", label: t("options.country.TW") },
    { value: "TZ", label: t("options.country.TZ") },
    { value: "TF", label: t("options.country.TF") },
    { value: "IO", label: t("options.country.IO") },
    { value: "TP", label: t("options.country.TP") },
    { value: "TG", label: t("options.country.TG") },
    { value: "TK", label: t("options.country.TK") },
    { value: "TO", label: t("options.country.TO") },
    { value: "TT", label: t("options.country.TT") },
    { value: "TA", label: t("options.country.TA") },
    { value: "TN", label: t("options.country.TN") },
    { value: "TR", label: t("options.country.TR") },
    { value: "TM", label: t("options.country.TM") },
    { value: "TV", label: t("options.country.TV") },
    { value: "UA", label: t("options.country.UA") },
    { value: "UG", label: t("options.country.UG") },
    { value: "HU", label: t("options.country.HU") },
    { value: "UY", label: t("options.country.UY") },
    { value: "UZ", label: t("options.country.UZ") },
    { value: "VU", label: t("options.country.VU") },
    { value: "VE", label: t("options.country.VE") },
    { value: "VN", label: t("options.country.VN") },
    { value: "WF", label: t("options.country.WF") },
    { value: "YE", label: t("options.country.YE") },
    { value: "ZM", label: t("options.country.ZM") },
    { value: "ZW", label: t("options.country.ZW") },
  ];
};
